import { useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { useLink } from "../../hooks/links"
import { useProducts } from "../../hooks/products"
import { useBeforeunload } from "../../hooks/utils"
import {
  useDisclosure,
  Box,
  Container,
  Center,
  Heading,
  Spinner,
} from "@chakra-ui/react"
import ProductList from "../../components/Shop/ProductList"
import Toolbar from "../../components/Shop/Toolbar"
import OrderForm from "../../components/Shop/OrderForm"

const LinkPage = () => {
  let history = useHistory()
  const modalController = useDisclosure()

  const { linkId } = useParams()
  const { link, placeOrder, locations } = useLink(linkId)
  const { products, isLoading } = useProducts()

  const [cart, setCart] = useState({})

  useBeforeunload(() => "Lasciando la pagina perderai il tuo ordine!")

  const onSubmit = (values) => {
    placeOrder({ ...values, cart, linkId: link.id }).then((docRef) =>
      history.push(`/conferma/${docRef.id}`)
    )
  }

  // 8e6800
  return (
    <Box as="main" minH="100vh">
      <Container maxW="container.sm" padding="4">
        <Heading align="center">Agrifood Loghino Vittoria</Heading>
      </Container>

      <Container maxW="container.sm" padding="4" mb={16}>
        {isLoading || link === undefined ? (
          <Center>
            <Spinner />
          </Center>
        ) : link.active === undefined ? (
          <Heading align="center">Link Inesistente</Heading>
        ) : link.active === false ? (
          <Heading align="center">Link Scaduto</Heading>
        ) : (
          <ProductList
            items={products.filter((product) =>
              link.selectedProducts.includes(product.id)
            )}
            cart={cart}
            setCart={setCart}
          />
        )}
      </Container>

      {link?.active && (
        <Toolbar
          cart={cart}
          onOrderClick={() => {
            modalController.onOpen()
          }}
        />
      )}

      {link?.active && (
        <OrderForm
          isLoading={false}
          onSubmit={onSubmit}
          modalController={modalController}
          locations={locations}
        />
      )}
    </Box>
  )
}

export default LinkPage
